
export default class FormAssets {

    static init(form) {
		const fileInputs = form.querySelectorAll('input[type="file"]');
	
		fileInputs.forEach(input => {
			input.onchange = function () {
				const id = input.id;
	
				let fileName = input.files.length + ' File(s)';
				switch (input.files.length) {
					case 0:
						fileName = '';
						break;
					case 1:
						fileName = input.files[0].name;
						break;
				}
	
				const imageElement = document.querySelector('.uploaded-image[data-input="' + id + '"]');
				const fileNameElement = document.querySelector('.file-name[data-input="' + id + '"]');
	
				if (imageElement) {
					if (input.files && input.files[0]) {
						var reader = new FileReader();
						reader.onload = (e) => {
							imageElement.style.backgroundImage = 'url(' + e.target.result + ')';
						};
						reader.readAsDataURL(input.files[0]);
					} else {
						imageElement.style.backgroundImage = null;
					}
				} else fileNameElement.innerHTML = fileName;
			};
		});
	}
}